<template>
    <div v-if="status.length" class="ecm-status">
        <ul class="ecm-status-list">
            <li
                v-for="statusText in status"
                :key="statusText">
                {{ statusText }}
            </li>
        </ul>
    </div>
</template>

<script>
import { eventBus } from "../main.js";

export default {
    name: 'Status',
    data() {
        return {
            status: []
        }
    },
    created() {
        eventBus.$on('addStatus', (status) => {
            if (! this.status.includes(status)) {
                this.status.push(status);
            }
        });

        eventBus.$on('removeStatus', (status) => {
            let index = this.status.indexOf(status);
            if (index > -1) {
                this.status.splice(index, 1);
            }
        });
    },
    methods: {

    }
}

</script>

<style scoped>

</style>
